import { Button, Col, Row, Switch, Table, Typography } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import NumberFormat from 'react-number-format';

import CardAviso from '../../../../components/CardAviso';
import {
  moneyConfig,
  percentageConfig,
  showErrors,
} from '../../../../helpers/form';
import { removePorcentagemMoedaMask } from '../../../../helpers/formatador';
import { Modal } from '../../../../styles/global';
import { columns } from './columns';
import { ColAdicionarFaixa, ItemForm, Paragrafo, Texto } from './styles';

function TarifasCliente({
  form,
  tarifas,
  setTarifas,
  inputTarifa,
  setInputTarifa,
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingKey, setEditingKey] = useState(null);

  const changeModalVisible = () => setIsModalVisible(!isModalVisible);

  const handleOk = () => {
    setInputTarifa(!inputTarifa);
    changeModalVisible();
  };

  const tipoTarifaExplicacao = (
    <Texto>
      <Paragrafo>
        Tarifa Percentual - O cliente paga um percentual em cima de cada Frete
      </Paragrafo>
      <Paragrafo>
        Tarifa em Reais - O Cliente paga valor fixo por Tonelada
      </Paragrafo>
    </Texto>
  );

  const adicionarFaixaDeValor = () => {
    const { tarifaInicial, tarifaFinal, tarifaTmov } = form.getFieldsValue();

    if (!tarifaTmov) {
      return showErrors(['É preciso informar o valor por tonelada']);
    }

    const tarifa_final = removePorcentagemMoedaMask(tarifaFinal || 0);
    const valorTarifaTmov = removePorcentagemMoedaMask(tarifaTmov);

    if (tarifas.length && tarifaInicial >= tarifa_final) {
      return showErrors(['A tarifa final deve ser maior que a tarifa inicial']);
    }

    let novaTarifa;

    let ultimaTarifa = tarifas.pop() || {
      valor_inicial: 0,
      valor_final: 9_999_999,
      valor_tarifa_percentual: valorTarifaTmov,
      valor_tarifa_reais_tonelada: valorTarifaTmov,
    };

    if (!tarifa_final) {
      tarifas.push(ultimaTarifa);
    } else {
      novaTarifa = {
        valor_inicial: ultimaTarifa.valor_inicial,
        valor_final: tarifa_final,
        valor_tarifa_percentual: valorTarifaTmov,
        valor_tarifa_reais_tonelada: valorTarifaTmov,
      };

      ultimaTarifa = {
        valor_inicial: tarifa_final + 0.01,
        valor_final: ultimaTarifa.valor_final,
        valor_tarifa_percentual: ultimaTarifa.valor_tarifa_percentual,
        valor_tarifa_reais_tonelada: ultimaTarifa.valor_tarifa_reais_tonelada,
      };

      tarifas.push(novaTarifa, ultimaTarifa);
    }

    setTarifas([...tarifas]);
    form.setFieldsValue({
      tarifaInicial: tarifa_final + 0.01,
      tarifaFinal: '',
      tarifaTmov: '',
    });
  };

  const deletarFaixaDeValor = () => {
    const novasTarifas = [...tarifas];

    if (!novasTarifas.length) return;

    let tarifaInicial = 0;
    const { valor_final } = novasTarifas.pop();
    const ultimaTarifa = novasTarifas[novasTarifas.length - 1];

    if (ultimaTarifa) {
      tarifaInicial = ultimaTarifa.valor_inicial;
      ultimaTarifa.valor_final = valor_final;
    }

    setTarifas(novasTarifas);
    form.setFieldsValue({
      tarifaInicial,
    });
  };

  const saveValue = () => {
    const { editingField } = form.getFieldsValue();
    const valueFormated = removePorcentagemMoedaMask(editingField);

    if (!valueFormated) return setEditingKey(null);

    const { valor_inicial, valor_final } = tarifas[editingKey];

    tarifas[editingKey] = {
      valor_inicial,
      valor_final,
      valor_tarifa_percentual: valueFormated,
      valor_tarifa_reais_tonelada: valueFormated,
    };

    setEditingKey(null);
    setTarifas([...tarifas]);
  };

  const startEditing = (key, tarifa) => {
    setEditingKey(key);
    form.setFieldsValue({
      editingField: tarifa,
    });
  };

  const keyPressedEditableField = event => event.key === 'Enter' && saveValue();
  const keyPressedAdicionaFaixaValor = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      adicionarFaixaDeValor();
    }
  };

  const columnsTable = columns(
    tarifas.length,
    editingKey,
    inputTarifa,
    deletarFaixaDeValor,
    saveValue,
    startEditing,
    keyPressedEditableField
  );

  return (
    <>
      <Row gutter={[0, 12]}>
        <Col span={24}>
          <ItemForm
            name="tipoTarifa"
            label="Tipo Tarifa"
            labelAlign="right"
            className="mb-5"
            tooltip={tipoTarifaExplicacao}
          >
            <Switch
              size="default"
              checked={inputTarifa}
              checkedChildren="%"
              unCheckedChildren="R$"
              onChange={changeModalVisible}
            />
          </ItemForm>
        </Col>
      </Row>
      <Row gutter={6} align="bottom">
        <Col xs={24} sm={12} md={12} lg={5} xl={4}>
          <ItemForm name="tarifaInicial" label="Valor frete motorista">
            <NumberFormat disabled placeholder="De R$" {...moneyConfig} />
          </ItemForm>
        </Col>
        <Col xs={24} sm={12} md={12} lg={5} xl={4}>
          <ItemForm name="tarifaFinal">
            <NumberFormat
              {...moneyConfig}
              isAllowed={() => true}
              placeholder="Até R$"
              onKeyPress={keyPressedAdicionaFaixaValor}
            />
          </ItemForm>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6} xl={5}>
          <ItemForm name="tarifaTmov" label="Valor cobrado por tonelada">
            <NumberFormat
              {...(inputTarifa ? percentageConfig : moneyConfig)}
              isAllowed={() => true}
              onKeyPress={keyPressedAdicionaFaixaValor}
            />
          </ItemForm>
        </Col>
        <ColAdicionarFaixa span={3}>
          <Button type="primary" onClick={adicionarFaixaDeValor}>
            Adicionar
          </Button>
        </ColAdicionarFaixa>
      </Row>
      <Row>
        <CardAviso className="pt-5" title="Importante:">
          Para editar uma faixa basta clicar no valor que deseja editar.
        </CardAviso>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            bordered={true}
            columns={columnsTable}
            pagination={false}
            dataSource={tarifas.map((client, key) => ({
              ...client,
              key,
            }))}
          />
        </Col>
      </Row>

      <Modal
        title="Atenção"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={changeModalVisible}
      >
        <Typography.Paragraph>
          Ao alterar o tipo da Tarifa TMOV, esteja ciente que irá refletir em
          cálculos ao edita/criar lotes.
        </Typography.Paragraph>
      </Modal>
    </>
  );
}

TarifasCliente.propTypes = {
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  ).isRequired,
  tarifas: PropTypes.arrayOf(PropTypes.object).isRequired,
  setTarifas: PropTypes.func.isRequired,
  inputTarifa: PropTypes.bool.isRequired,
  setInputTarifa: PropTypes.func.isRequired,
};

export default TarifasCliente;
